var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"pc_common",class:[
    'page-common', 
    _vm.customClassProp, 
    `detect_deviece_${_vm.deviceType}`, 
    `state_${_vm.deviceType}`,
  ]},[_c('AppHeader',{class:[
    `app_device_detect_is_${_vm.deviceType}`
  ]}),_vm._t("default"),_c('AppFooter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }